<template>
  <div class="ren-decoration-cp ren-decoration-cp-content-moment-media">
    <img v-if="imageUrl" :src="imageUrl" alt="" />
    <span v-else>动态媒体</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { previewDataRecord, recordList, stringValue } from '../../../previews/preview-helpers'
import { widgetMediaUrl } from '../../media'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()
const data = computed(() => previewDataRecord(props.componentData))
const imageUrl = computed(() => {
  const media = recordList(data.value.media ?? data.value.images)
  const first = media[0]
  const raw = first ? stringValue(first.url ?? first.imageUrl ?? first.coverUrl) : stringValue(data.value.coverUrl)
  return widgetMediaUrl(raw)
})
</script>

<style scoped>
.ren-decoration-cp-content-moment-media {
  display: grid;
  place-items: center;
  min-height: 140px;
  overflow: hidden;
  background: var(--ren-theme-background);
  color: var(--ren-theme-muted);
}
.ren-decoration-cp-content-moment-media img {
  width: 100%;
  height: 140px;
  object-fit: cover;
}
</style>
